import ContactStatus from '@/models/Contacts/ContactStatus';

export default class ContactStatusViewModel {
    name: string;
    value: ContactStatus;

    public constructor(name: string, value: ContactStatus) {
        this.name = name;
        this.value = value;
    }
}